import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'

import {AttentionIcon} from '../../icons'

const SubsectionAlert = ({text}) =>
  text && (
    <Box
      bg="mld.neutral.0"
      p="sm"
      borderRadius="md"
      borderColor="mld.neutral.800"
      borderWidth={1}
      display="flex"
      alignItems="flex-start"
    >
      <Box mr="md">
        <AttentionIcon width="1.5em" height="1.5em" />
      </Box>
      <Box flex="1">
        <Text>{text}</Text>
      </Box>
    </Box>
  )

SubsectionAlert.propTypes = {
  text: PropTypes.string,
}

SubsectionAlert.defaultProps = {
  text: null,
}

export default SubsectionAlert
